import React, { PureComponent } from 'react'
import { array, func } from 'prop-types'
import { connect } from 'react-redux'
import { updateStreetViewCenter } from '../../store/Actions/MapActions'
import CloseStreetView from './CloseStreetView'
import './styles/StreetView.css'

class StreetView extends PureComponent {
  componentDidMount = () => {
    const map = {
      lat: this.props.center[1],
      lng: this.props.center[0],
    }

    // eslint-disable-next-line
    let panorama = new window.google.maps.StreetViewPanorama(
      document.getElementById('streetViewContainer'),
      {
        position: map,
        linksControl: false,
        panControl: true,
        source: window.google.maps.StreetViewSource.OUTDOOR,
        fullScreenControl: false,
        zoomControl: false,
        scaleControl: false,
        addressControl: false,
        pov: {
          heading: 34,
          pitch: 10,
        },
      }
    )

    panorama.addListener('position_changed', () => {
      this.props.updateStreetViewCenter({
        lng: panorama.getPosition().lng(),
        lat: panorama.getPosition().lat(),
      })
    })
  }

  render() {
    return (
      <div id="streetViewContainer">
        <CloseStreetView />
      </div>
    )
  }
}

StreetView.propTypes = {
  center: array.isRequired,
  updateStreetViewCenter: func.isRequired,
}

const mapStateToProps = ({ map }) => ({
  center: [map.streetViewCenter.lng, map.streetViewCenter.lat],
})

const mapDispatchToProps = dispatch => ({
  updateStreetViewCenter: value => dispatch(updateStreetViewCenter(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(StreetView)



// WEBPACK FOOTER //
// ./src/components/StreetView/index.jsx